<div fxLayout="column" fxFlex fxLayoutGap="24px">
  <!-- Header -->
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2>Generate Presentation Request</h2>
    <button mat-icon-button [routerLink]="['../']" matTooltip="Back to Presentation">
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>

  <!-- Loading State -->
  @if (loading) {
    <div fxLayout="row" fxLayoutAlign="center center" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Loading configurations...</span>
    </div>
  }

  <!-- Main Content -->
  @if (!loading) {
    <div fxLayout="column" fxLayoutGap="24px">
      <!-- Form Section -->
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <!-- Configuration Selection Card -->
        <mat-card class="form-card">
          <mat-card-header>
            <mat-card-title>
              <mat-icon>settings</mat-icon>
              Request Configuration
            </mat-card-title>
            <mat-card-subtitle>
              Select a presentation configuration to generate a presentation request
            </mat-card-subtitle>
          </mat-card-header>
          <mat-card-content fxLayout="column" fxLayoutGap="16px">
            <!-- Presentation Configuration Selection -->
            <mat-form-field>
              <mat-label>Presentation Configuration</mat-label>
              <mat-select formControlName="requestId" [disabled]="generatingOffer">
                <mat-option value="">Select a configuration</mat-option>
                @for (config of configs; track config.id) {
                  <mat-option [value]="config.id">
                    {{ config.id }}
                  </mat-option>
                }
              </mat-select>
              <mat-icon matSuffix>rule</mat-icon>
              @if (form.get('requestId')?.invalid && form.get('requestId')?.touched) {
                <mat-error>Please select a presentation configuration</mat-error>
              }
            </mat-form-field>
          </mat-card-content>
          <mat-card-actions fxLayout="row" fxLayoutAlign="end center">
            <button
              mat-flat-button
              color="primary"
              type="submit"
              [disabled]="form.invalid || generatingOffer"
            >
              Generate Request
            </button>
            <button mat-button type="button" (click)="resetForm()" [disabled]="generatingOffer">
              Reset
            </button>
          </mat-card-actions>
        </mat-card>
      </form>

      <!-- Selected Configuration Preview -->
      <div>
        @if (selectedConfig) {
          <mat-card class="preview-card">
            <mat-card-header>
              <mat-card-title>
                <mat-icon>preview</mat-icon>
                Configuration Preview
              </mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="config-preview">
                <div class="preview-item">
                  <strong>Configuration ID:</strong>
                  <span>{{ selectedConfig.id }}</span>
                </div>

                @if (selectedConfig.dcql_query) {
                  <div class="preview-item">
                    <strong>DCQL Query:</strong>
                    <pre class="dcql-query">{{ selectedConfig.dcql_query | json }}</pre>
                  </div>
                }

                @if (selectedConfig.webhook) {
                  <div class="preview-item">
                    <strong>Webhook URL:</strong>
                    <span>{{ selectedConfig.webhook.url }}</span>
                  </div>
                }

                @if (selectedConfig.registrationCert) {
                  <div class="preview-item">
                    <strong>Registration Certificate:</strong>
                    <span>{{ selectedConfig.registrationCert.id || 'Configured' }}</span>
                  </div>
                }

                @if (selectedConfig.createdAt) {
                  <div class="preview-item">
                    <strong>Created:</strong>
                    <span>{{ selectedConfig.createdAt | date: 'short' }}</span>
                  </div>
                }
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
    </div>

    <!-- No Configurations State -->
    @if (configs.length === 0) {
      <mat-card class="empty-state">
        <mat-card-content>
          <div fxLayout="column" fxLayoutAlign="center center" class="empty-content">
            <mat-icon>warning</mat-icon>
            <h3>No Presentation Configurations</h3>
            <p>
              You need to create at least one presentation configuration before generating requests.
            </p>
            <button
              mat-raised-button
              color="primary"
              [routerLink]="['../presentation-config/create']"
            >
              <mat-icon>add</mat-icon>
              Create Presentation Configuration
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    }
  }
</div>
